module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/finance.component.css
// module id = ./src/app/finance/finance.component.css
// module chunks = main